import { IconProps, iconColor } from './IconProps'

export function BlueTimeIcon(props: IconProps) {
  const size = props.size || 44

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='44' height='44' rx='22' fill='#0A85FF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.107 9.14294C15.5803 9.70704 15.5067 10.548 14.9426 11.0214L10.857 14.4496C10.2929 14.9229 9.45193 14.8493 8.9786 14.2852C8.50526 13.7211 8.57884 12.8801 9.14294 12.4068L13.2285 8.9786C13.7926 8.50526 14.6336 8.57884 15.107 9.14294ZM28.8979 9.14294C29.3712 8.57884 30.2122 8.50526 30.7763 8.9786L34.8619 12.4068C35.426 12.8801 35.4996 13.7211 35.0262 14.2852C34.5529 14.8493 33.7119 14.9229 33.1478 14.4496L29.0622 11.0214C28.4981 10.548 28.4245 9.70704 28.8979 9.14294ZM22 14C16.8453 14 12.6667 18.1787 12.6667 23.3333C12.6667 28.488 16.8453 32.6667 22 32.6667C27.1546 32.6667 31.3333 28.488 31.3333 23.3333C31.3333 18.1787 27.1546 14 22 14ZM9.99999 23.3333C9.99999 16.7059 15.3726 11.3333 22 11.3333C28.6274 11.3333 34 16.7059 34 23.3333C34 29.9607 28.6274 35.3333 22 35.3333C15.3726 35.3333 9.99999 29.9607 9.99999 23.3333ZM22 15.3333C22.7364 15.3333 23.3333 15.9303 23.3333 16.6667V22H28.6667C29.403 22 30 22.5969 30 23.3333C30 24.0697 29.403 24.6667 28.6667 24.6667H22C21.2636 24.6667 20.6667 24.0697 20.6667 23.3333V16.6667C20.6667 15.9303 21.2636 15.3333 22 15.3333Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
